import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

type InfoBlockWrapperProps = {
    showMobileMore: boolean;
};

const InfoBlockWrapper = ({
    children,
    showMobileMore
}: RequireChildrenFor<InfoBlockWrapperProps>) => {
    return (
        <section
            className={cn(
                "tw:max-lg:border-y tw:max-lg:border-y-grey-light tw:max-lg:-mt-px tw:group/info-block",
                "js-info-block js-anchor-scroll-spy__block",
                {
                    "info-block--active": showMobileMore
                }
            )}
        >
            {children}
        </section>
    );
};

export { InfoBlockWrapper };
